import isEmpty from 'lodash/isEmpty';
import useAccountingConnectionState from '~/hooks/useAccountingConnectionState';
import { useAllAccountsQuery } from '~/services/account';
import { useHasSeeInvoices, useHasTreasury } from './useFeatureFlag';

interface GettingStartedTasksCount {
  isLoading: boolean;
  gettingStartedTasksCount: number;
}

const useGettingStartedTasksCount = (): GettingStartedTasksCount => {
  const accountsQuery = useAllAccountsQuery();
  const connectionState = useAccountingConnectionState();

  const hasTreasury = useHasTreasury();
  const hasSeeInvoices = useHasSeeInvoices();

  const gettingStartedTasksCount = [
    connectionState.state === 'connect' && hasSeeInvoices,
    accountsQuery.data && isEmpty(accountsQuery.data) && hasTreasury,
  ].filter(Boolean).length;

  const isLoading = accountsQuery.isLoading || connectionState.state === 'loading';

  return { isLoading, gettingStartedTasksCount };
};

export default useGettingStartedTasksCount;
